<div class="dlg-container" (click)="$event.stopPropagation()">
    <!--  *** GROUP ADD *** -->
    <div *ngIf="data.type == GROUP_ADD" class="dlg-contents dlg-select-input-container">
        <div class="dlg-title" data-cy="channels-create-channel-group-modal-header">
            {{ 'channel.add-group' | translate }}
        </div>
        <div class="dlg-inputs">
            <div class="dlg-input">
                <app-channel-text-input
                    name="displayName"
                    label="channel.create.group.form.name"
                    [value]="editDisplayName"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.displayName"></app-channel-text-input>
            </div>
            <div class="dlg-input">
                <app-channel-text-input
                    name="displayNumber"
                    label="channel.create.group.form.number"
                    [value]="editDisplayNumber"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.displayNumber"></app-channel-text-input>
            </div>
            <div class="dlg-input select">
                <app-channel-select-input
                    name="categoryId"
                    label="channel.create.group.form.category"
                    [height]="110"
                    [value]="data?.selectedChannelGroup?.categoryId"
                    (inputChange)="onInputChange($event)"
                    [categoryList]="channelCategoryList"></app-channel-select-input>
            </div>
        </div>
        <div class="dlg-buttons">
            <button (click)="cancelButtonClick()" data-cy="channels-create-channel-group-cancel-button" class="primary">
                {{ 'dlg.cancel' | translate }}
            </button>
            <button
                (click)="confirmButtonClick()"
                class="white"
                data-cy="channels-create-channel-group-submit-button"
                [class.disabledButton]="saveIsDisabled()">
                {{ 'dlg.create' | translate }}
            </button>
        </div>
    </div>
    <!--  *** GROUP EDIT *** -->
    <div *ngIf="data.type === GROUP_EDIT" class="dlg-contents dlg-select-input-container">
        <div class="dlg-title" data-cy="channels-edit-channel-group-modal-header">
            {{ data.title | translate }}
        </div>
        <div class="dlg-inputs">
            <div class="dlg-input">
                <app-channel-text-input
                    name="displayName"
                    label="channel.create.group.form.name"
                    [value]="editDisplayName"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.displayName"></app-channel-text-input>
            </div>
            <div class="dlg-input">
                <app-channel-text-input
                    name="displayNumber"
                    label="channel.create.group.form.number"
                    [value]="editDisplayNumber"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.displayNumber"
                    [maxLength]="3"></app-channel-text-input>
            </div>
            <div class="dlg-input select">
                <app-channel-select-input
                    name="categoryId"
                    label="channel.create.group.form.category"
                    [height]="110"
                    [value]="
                        isSystemGroup()
                            ? data.selectedChannelGroup.channelCategory.category
                            : data.selectedChannelGroup.categoryId
                    "
                    [isDisabled]="isSystemGroup()"
                    [categoryList]="channelCategoryList"
                    (inputChange)="onInputChange($event)"></app-channel-select-input>
            </div>
        </div>
        <div class="dlg-buttons">
            <button (click)="cancelButtonClick()" data-cy="channels-edit-channel-group-cancel-button" class="primary">
                {{ 'dlg.cancel' | translate }}
            </button>
            <button
                (click)="confirmButtonClick()"
                class="white"
                data-cy="channels-edit-channel-group-submit-button"
                [class.disabledButton]="saveIsDisabled()">
                {{ 'dlg.save' | translate }}
            </button>
        </div>
    </div>
    <!--  *** GROUP DELETE *** -->
    <div *ngIf="data.type == GROUP_DELETE" class="dlg-contents">
        <div class="dlg-title" *ngIf="data.title" data-cy="channels-delete-channel-group-modal-header">
            {{ data.title | translate }}
        </div>
        <div class="dlg-description" [class.no-margin]="!data.title" data-cy="channels-delete-channel-group-modal-body">
            {{ data.description | translate }}
        </div>
        <div class="dlg-buttons">
            <button (click)="cancelButtonClick()" data-cy="channels-delete-channel-group-cancel-button" class="primary">
                {{ 'dlg.cancel' | translate }}
            </button>
            <button (click)="confirmButtonClick()" data-cy="channels-delete-channel-group-submit-button" class="white">
                {{ 'dlg.confirm' | translate }}
            </button>
        </div>
    </div>
    <!--  *** DESCRIPTION *** -->
    <div *ngIf="data.type == GROUP_DESCRIPTION" class="dlg-contents">
        <div
            class="dlg-description"
            data-cy="channels-import-data-fix-prefilled-fields-modal-text"
            [class.no-margin]="!data.title">
            {{ data.description | translate }}
        </div>
        <div class="dlg-buttons">
            <button
                (click)="close()"
                class="primary"
                data-cy="channels-import-data-fix-prefilled-fields-modal-cancel-btn">
                {{ 'dlg.cancel' | translate }}
            </button>
            <button
                (click)="dialogRef.close(true)"
                class="white"
                data-cy="channels-import-data-fix-prefilled-fields-modal-confirm-btn">
                {{ 'dlg.confirm' | translate }}
            </button>
        </div>
    </div>
</div>
